import { ref, reactive, onBeforeMount, watch } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import inventoryHistoryModel from "@/models/inventory/inventory-history";
import usePagination from "@/views/components/pagination/usePagination";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useDate from "@/utils/hooks/useDate";

export default function useInventoryHistoryGroup() {
  const { fetchInventoryHistoryGroupList } = inventoryHistoryModel();
  const { pagination, onPageChange, onFilterEntity } = usePagination();
  const { filters, ordering, onSetValueSearch } = useFilterHeaderTable();
  const { openDefaultErrorModal, openErrorModal } = useValidationModal();
  const {resolveDateWithSeperator} = useDate();

  const loading = reactive({
    tableData: false,
  });

  const fields = [
    { key: "seq", label: "No." },
    { key: "inv_reference", label: "Reference" },
    { key: "inventory_name", label: "Inventory Name" },
    { key: "remaining_qty", label: "Balance" },
    { key: "total_qty", label: "Total" },
    { key: "withdraw_qty", label: "Withdraw" },
    { key: "expired_qty", label: "Expired" },
    { key: "updatedtime", label: "Latest Update" },
    { key: "actions", label: "" },
  ];

  const inventoryHistoryTable = reactive({
    payload: [],
  });

  const privilegeDetail = reactive({
    ref: "",
    nameEn: "",
    nameTh: "",
    image: "",
  });

  const routeHistoryDetail = (item) => {
    router
      .push(
        "/inventory/privilege/history/group/" +
          router.currentRoute.params.ref +
          "/detail/" +
          item.inventory_id
      )
      .catch(() => {});
  };

  const fetchHistoryGroupList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true;
    }
    fetchInventoryHistoryGroupList.payload.Privilege_Id = router.currentRoute.params.ref;
    fetchInventoryHistoryGroupList.payload.Page = pagination.currentPage;
    fetchInventoryHistoryGroupList.payload.Limit = pagination.perPage;
    fetchInventoryHistoryGroupList.payload.Filters = filters;
    fetchInventoryHistoryGroupList.payload.Ordering = ordering.value;
    store
      .dispatch("api/apiRequest", fetchInventoryHistoryGroupList)
      .then((response) => {
        inventoryHistoryTable.payload = response.data.paylaod.inventory_list;
        pagination.rows = response.data.paylaod.inventory_list.length;
        pagination.totalRows = response.data.filtered_record; // ขาด filter_record
        privilegeDetail.ref = response.data.paylaod.privilege_reference;
        // privilegeDetail.name = "En: " + response.data.paylaod.privilege_name_en + "\n" + "Th: " + response.data.paylaod.privilege_name_th;
        privilegeDetail.nameEn = response.data.paylaod.privilege_name_en
        privilegeDetail.nameTh = response.data.paylaod.privilege_name_th
        privilegeDetail.image = response.data.paylaod.privilege_image_url;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchHistoryGroupList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchHistoryGroupList();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    fetchHistoryGroupList();
  });

  return {
    fields,
    loading,
    inventoryHistoryTable,
    privilegeDetail,
    pagination,
    onPageChange,
    onSetValueSearch,
    routeHistoryDetail,
    resolveDateWithSeperator,
    onFilterEntity
  };
}
